import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import AuthPage from "./pages/AuthPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Dashboard from "./pages/Dashboard";
import TransactionsPage from "./pages/TransactionsPage";
import ReportsPage from "./pages/ReportsPage";
import ProfilePage from "./pages/ProfilePage";
import PaywallPage from "./pages/PaywallPage";
import AdminPage from "./pages/AdminPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import DeleteAccountPublicPage from "./pages/DeleteAccountPublicPage";
import { PaymentSuccessPage, PaymentCancelPage } from "./pages/PaymentResultPages";
import BottomNav from "./components/BottomNav";
import InstallPwaBanner from "./components/InstallPwaBanner";

function Protected({ requireLicense = true }) {
  const { user, license, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Carregando…</div>;
  if (!user) return <Navigate to="/entrar" replace />;
  // Gate: if license is not active, send to paywall — except when already on payment flow pages
  const payPaths = ["/pagar", "/pagamento/sucesso", "/pagamento/cancelado", "/perfil"];
  if (requireLicense && license && !license.is_active && !payPaths.includes(location.pathname)) {
    return <Navigate to="/pagar" replace />;
  }
  return (
    <div className="min-h-screen pb-40 sm:pb-10">
      <Outlet />
      <BottomNav />
      <InstallPwaBanner />
    </div>
  );
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Carregando…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function OwnerOnly() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Carregando…</div>;
  if (!user) return <Navigate to="/entrar" replace />;
  if (user.role !== "owner") return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen pb-40 sm:pb-10">
      <Outlet />
      <BottomNav />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App grain">
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/entrar" element={<PublicOnly><AuthPage /></PublicOnly>} />
            <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
            <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
            <Route path="/excluir-conta" element={<DeleteAccountPublicPage />} />
            <Route element={<Protected />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/movimentacoes" element={<TransactionsPage />} />
              <Route path="/relatorios" element={<ReportsPage />} />
              <Route path="/perfil" element={<ProfilePage />} />
              <Route path="/pagar" element={<PaywallPage />} />
              <Route path="/pagamento/sucesso" element={<PaymentSuccessPage />} />
              <Route path="/pagamento/cancelado" element={<PaymentCancelPage />} />
            </Route>
            <Route element={<OwnerOnly />}>
              <Route path="/admin" element={<AdminPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
